import { Component } from '@angular/core';
import type { OnInit } from '@angular/core';
import { ModalController, NavParams, IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    'selector': 'app-pickupRequestModal',
    'templateUrl': './pickupRequestModal.page.html',
    'styleUrls': ['./pickupRequestModal.page.scss'],
    'standalone': true,
    imports: [IonicModule, CommonModule, FormsModule]
})
export class PickupRequestModalPage implements OnInit {
    public ticket: any = {};
    private intervalPromise: any;

    constructor(public modalController: ModalController, private navParams: NavParams) {
    }

    public ngOnInit(): void {
        this.ticket = this.navParams.get('ticket');
        this.ticket.timeRemaining = 11;
        const interval = 1000;

        this.intervalPromise = setInterval(async () => {
            if (--this.ticket.timeRemaining === 0) {
                await this.onDeclineClick();
            }
        }, interval);
    }

    public async onAcceptClick() {
        clearInterval(this.intervalPromise);
        await this.modalController.dismiss({ 'accept': true });
    }

    public async onDeclineClick() {
        clearInterval(this.intervalPromise);
        await this.modalController.dismiss({ 'accept': false });
    }
}
